import { Fragment } from "react";
import { TrendingUp, TrendingDown, FileSpreadsheet, FileText } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

const fmt = (v) => (v == null ? "—" : `${Number(v).toLocaleString("es-ES", { maximumFractionDigits: 1 })}%`);

export const evoDelta = (vals = []) => {
  const first = vals.find((v) => v != null);
  const last = vals[vals.length - 1];
  return vals.length > 1 && first != null && last != null ? Math.round((last - first) * 10) / 10 : null;
};

export function EvoHeaders({ months = [], cls = "px-3 py-2", light = false }) {
  if (months.length < 2) return null;
  return (
    <>
      {months.map((m) => (
        <th key={m.id} className={`text-right ${cls} whitespace-nowrap ${light ? "bg-sky-50 text-sky-900" : "bg-sky-900/40"}`} title={m.is_base ? "Mes base" : m.label}>
          {m.label}{m.is_base && <span className={`ml-1 ${light ? "text-amber-700" : "text-amber-300"}`}>· base</span>}
        </th>
      ))}
      <th className={`text-right ${cls} whitespace-nowrap ${light ? "bg-sky-50 text-sky-900" : "bg-sky-900/40"}`}>Evolución</th>
    </>
  );
}

export function EvoCells({ values = [], months = [], cls = "px-3 py-2", testid }) {
  if (months.length < 2) return null;
  const d = evoDelta(values);
  return (
    <>
      {values.map((v, i) => {
        const prev = i > 0 ? values[i - 1] : null;
        const up = v != null && prev != null && v > prev;
        const down = v != null && prev != null && v < prev;
        return (
          <td key={i} className={`${cls} text-right font-mono-num whitespace-nowrap ${up ? "text-emerald-700" : down ? "text-rose-600" : "text-slate-600"}`}>
            {fmt(v)}
          </td>
        );
      })}
      <td className={`${cls} text-right font-mono-num font-bold whitespace-nowrap ${(d || 0) > 0 ? "text-emerald-600" : (d || 0) < 0 ? "text-rose-600" : "text-slate-400"}`} data-testid={testid}>
        {d == null ? "—" : (
          <span className="inline-flex items-center gap-0.5 justify-end">
            {d > 0 ? <TrendingUp className="h-3 w-3" /> : d < 0 ? <TrendingDown className="h-3 w-3" /> : null}
            {d > 0 ? "+" : ""}{d.toLocaleString("es-ES")} pp
          </span>
        )}
      </td>
    </>
  );
}

export function EvoExportButtons({ url, filename, testid }) {
  const download = async (kind) => {
    try {
      const { data } = await api.get(url, { params: { export: kind }, responseType: "blob" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(data);
      a.download = `${filename}.${kind === "excel" ? "xlsx" : "pdf"}`;
      a.click();
      URL.revokeObjectURL(a.href);
    } catch {
      toast.error("No se pudo descargar el informe");
    }
  };
  return (
    <span className="inline-flex gap-1.5">
      {[["excel", "Excel", FileSpreadsheet], ["pdf", "PDF", FileText]].map(([k, label, Icon]) => (
        <Fragment key={k}>
          <button type="button" onClick={() => download(k)} data-testid={`${testid}-${k}`}
            className="inline-flex items-center gap-1 text-xs font-semibold border border-slate-300 bg-white rounded-md px-2.5 py-1 hover:bg-slate-50">
            <Icon className="h-3.5 w-3.5" /> {label}
          </button>
        </Fragment>
      ))}
    </span>
  );
}
